const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <p>Loading Questions</p>
    </div>
  );
};

export default Loader;
